import { Link } from 'react-router-dom';
import { profile } from '../../data/profile';
import { ui } from '../../data/ui';
import './Footer.css';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <span className="logo-accent">ماهر</span>
              <span> ملحم</span>
            </Link>
            <p className="footer-tagline">{profile.tagline}</p>
            <p className="footer-experience">
              {profile.yearsOfExperience}+ {ui.hero.yearsExperience} · {ui.hero.since} {profile.careerStartYear}
            </p>
          </div>

          <div className="footer-links">
            <h4>{ui.footer.navigation}</h4>
            <Link to="/experience">{ui.nav.experience}</Link>
            <Link to="/projects">{ui.nav.projects}</Link>
            <Link to="/services">{ui.nav.services}</Link>
            <Link to="/resume">{ui.nav.resume}</Link>
            <Link to="/contact">{ui.nav.contact}</Link>
          </div>

          <div className="footer-links">
            <h4>{ui.footer.connect}</h4>
            {profile.socialLinks.map((link) => {
              const isPlaceholder = link.url.startsWith('[');
              if (isPlaceholder) {
                return (
                  <span key={link.name} className="footer-link-placeholder">
                    {link.name}
                  </span>
                );
              }
              return (
                <a
                  key={link.name}
                  href={link.url}
                  target={link.url.startsWith('http') ? '_blank' : undefined}
                  rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  {link.name}
                </a>
              );
            })}
            <span className="footer-location">{profile.location}</span>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {currentYear} {profile.name}. {ui.footer.rights}</p>
          <p className="footer-built">{ui.footer.builtWith}</p>
        </div>
      </div>
    </footer>
  );
}
